import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🚀 TASK: Verify that the CP4AIOPS Installation is ready`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=aiops-starter-installation" target="_blank">🌏 Documentation for the Task: Online starter installation of CP4AIOPS</a>
    <p>{`Check that CP4AIOPS is running and that you can continue with the next chapter to install the third-party systems that will support your training.`}</p>
    <p>{`You can do this by checking the running Pods in the `}<inlineCode parentName="p">{`ibm-aiops`}</inlineCode>{` Namespace.`}</p>
    <p>{`There should be more than 116 Pods with Status `}<inlineCode parentName="p">{`Running`}</inlineCode>{` and all should be `}<inlineCode parentName="p">{`Ready`}</inlineCode>{` (meaning they have show 1/1, 2/2, 3/3, 4/4, …)`}</p>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <h2>{`Check with the Command Line`}</h2>
        <p>{`Run the following:`}</p>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`while :; do clear; echo "Checking..."; echo "Exit with Ctrl-C"; echo "---------------"; echo "Ready: $(oc get po -n ibm-aiops | grep -v Completed | grep -v Error |grep -v '0/' |wc -l| tr -d ' ')"; echo "Not Ready:     $(oc get po -n ibm-aiops | grep -v Completed | grep -v Error |grep '0/' |wc -l| tr -d ' ')"; echo "---------------"; oc get po -n ibm-aiops | grep -v Completed | grep -v Error |grep '0/'; sleep 5; done
`}</code></pre>
        <br />
        <p>{`This will list the Pods that are not Ready yet.`}</p>
        <br />
        <img {...{
          "src": "./../images/58_install_ok.png",
          "alt": "image"
        }}></img>
        <br />
        <p>{`✅ And `}<strong parentName="p">{`when done`}</strong>{` you should get 0 Pods `}<inlineCode parentName="p">{`Not Ready`}</inlineCode>{`, about `}<inlineCode parentName="p">{`Ready: 12x`}</inlineCode>{` and `}<inlineCode parentName="p">{`Not Ready: 0`}</inlineCode>{`.`}</p>
        <h2>{`Check with your OpenShift Web Console`}</h2>
        <ol>
          <li parentName="ol">
            <p parentName="li">{`Select `}<inlineCode parentName="p">{`Pods`}</inlineCode>{` and your `}<inlineCode parentName="p">{`ibm-aiops`}</inlineCode>{` Project`}</p>
            <img parentName="li" {...{
              "src": "./../images/03_fzth_aimanager_check.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Filter for the relevant statuses`}</p>
            <img parentName="li" {...{
              "src": "./../images/04_fzth_aimanager_check.png",
              "alt": "image"
            }}></img>
            <p parentName="li">{`The drop-down also shows you the number of Pods for the different statuses.`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Sort by `}<inlineCode parentName="p">{`Ready`}</inlineCode>{` column`}</p>
            <img parentName="li" {...{
              "src": "./../images/05_fzth_aimanager_check.png",
              "alt": "image"
            }}></img>
          </li>
        </ol>
        <p>{`This allows you to follow along the progress of the installation.`}</p>
        <br />
        <br />
        <p>{`✅ `}<strong parentName="p">{`When done`}</strong>{` you should have more than 116 Pods in Running status and all Pods should be `}<inlineCode parentName="p">{`1/1, 2/2, 3/3, ...`}</inlineCode></p>
      </AccordionItem>
    </Accordion>
    <InlineNotification kind="error" mdxType="InlineNotification">
      <p><strong parentName="p">{`Important - This takes up to 90 minutes`}</strong></p>
      <p>{`This takes some time depending on what region of ROKS you have chosen.`}</p>
      <p>{`Wait for the installation to complete before continuing. `}</p>
      <p>{`The next step explains how to follow the installation progress.`}</p>
    </InlineNotification>
    <InlineNotification kind="warning" mdxType="InlineNotification">
      <p>{`🛠️ `}<strong parentName="p">{`Troubleshooting - Topology-Search Pod not starting`}</strong></p>
      <p>{`If you have over 116 pods running and`}</p>
      <p>{`if the `}<inlineCode parentName="p">{`aiops-topology-search-xxxx-xxxx`}</inlineCode>{` Pod is restarting (CrashLoopBackOff).`}</p>
      <p>{`🚀 Please execute the following:`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-shell"
        }}>{`oc patch deployment aiops-topology-search -n ibm-aiops --patch-file "./ansible/roles/ibm-aiops-install-instance/templates/aiops/patches/aiops-topology-search-patch.yaml"
`}</code></pre>
    </InlineNotification>
    <InlineNotification kind="warning" mdxType="InlineNotification">
      <p>{`🛠️ `}<strong parentName="p">{`Troubleshooting - Policy-Registry-Service Pod not starting`}</strong></p>
      <p>{`If you have about 125 pods running and`}</p>
      <p>{`if the `}<inlineCode parentName="p">{`aiops-ir-lifecycle-policy-registry-svc-xxxx-xxxx`}</inlineCode>{` Pod is restarting (CrashLoopBackOff).`}</p>
      <p>{`🚀 Please delete the Pod (you might have to do this several times). It should come up eventually.`}</p>
    </InlineNotification>
    <InlineNotification kind="success" mdxType="InlineNotification">
      <p><strong parentName="p">{`You have successfully finished this Chapter`}</strong></p>
      <p>{`You are now done with the chapter on Installing CP4AIOPS.`}</p>
      <p>{`Please continue to the next chapter to learn how to install the Training Resources.`}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      